<template>
  <div class="gf-project-owner-selector">
    <div v-if="selectedModel">
      <custom-select
        v-model="selectedModel"
        :options="groupedOptions"
        :searchable="searchable"
        :filterable="filterable"
        :taggable="taggable"
        @input="onChange"
      >
        <template slot-scope="{ option }">
          <span
            v-if="option.isSelectorGroupName"
            class="mb-0 text-muted"
          >
            {{ option.title }}
          </span>
          <user-label-item
            v-else
            :user="option"
            :class="!option.fullName ? 'ml-2' : ''"
          />
        </template>
      </custom-select>
    </div>
    <div v-else>
      <pacman-loader size="15" />
    </div>
    <input
      type="hidden"
      :id="hiddenInputId"
      :name="hiddenInputName"
      :value="selectedModel?.alias"
    />
  </div>
</template>

<script>
import CustomSelect from '@shared/shared-components/shared/custom-select';
import RepoS from '@shared/services/repository.service';
import AdminProjectCreateService from '@/shared-modules/modules/admin/admin-project-create/admin.project.create.service';
import AdminEntityCreateService from '@/shared-modules/modules/admin/admin-entity-create/admin.entity.create.service';
import UserLabelItem from '@shared/shared-components/shared/user-label-item';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';

export default {
  name: 'ProjectOwnerSelector',
  components: { CustomSelect, UserLabelItem, PacmanLoader },
  props: {
    createdObjectType: {
      type: String,
      default: 'PROJECT'
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    hiddenInputId: {
      type: String,
      default: 'projectOwnerAlias'
    },
    hiddenInputName: {
      type: String,
      default: 'ownerAlias'
    },
    searchable: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    taggable: {
      type: Boolean,
      default: false
    },
    isTransferRepository: {
      type: Boolean,
      default: false
    },
    projectAlias: {
      type: String,
      default: null
    },
    ownerAlias: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedModel: null,
      groupedOptions: [],
      teamHeader: {
        title: 'Команды',
        isSelectorGroupName: true
      },
      companyHeader: {
        title: 'Компании',
        isSelectorGroupName: true
      },
      ownerAliasFromQuery: null,
      ownerTypeFromQuery: 'USER'
    };
  },
  mounted() {
    this.getParamsFromURL();
    if (this.isAdmin) {
      if (this.createdObjectType === 'PROJECT') {
        AdminProjectCreateService.getAllowedOwners().then((res) => {
          this.makeGroupedOptions(res);
        });
      } else {
        AdminEntityCreateService.getAllowedTeamOwners().then((res) => {
          this.makeGroupedOptions(res);
        });
      }
    } else {
      if (this.createdObjectType === 'PROJECT') {
        if (this.isTransferRepository) {
          RepoS.getAllOwnersForTransfer(this.ownerAlias, this.projectAlias).then((res) => {
            this.makeGroupedOptions(res);
          });
        } else {
          RepoS.getAllowedOwners().then((res) => {
            this.makeGroupedOptions(res);
          });
        }
      } else {
        RepoS.getAllowedTeamOwners().then((res) => {
          this.makeGroupedOptions(res);
        });
      }
    }
  },
  methods: {
    makeGroupedOptions(data) {
      if (this.createdObjectType !== 'SUBGROUP') {
        if (this.isTransferRepository) {
          data.userSet.forEach((user) => {
            user.title = user.fullName;
            user.alias = user.username;
            (user.ownerType = 'USER'), this.groupedOptions.push(user);
          });
        } else {
          data.user.title = data.user.fullName;
          data.user.alias = data.user.username;
          data.user.ownerType = 'USER';
          this.groupedOptions.push(data.user);
        }
      } else {
        this.groupedOptions = [];
      }

      if (this.createdObjectType !== 'COMPANY') {
        if (data.teamSet?.length > 0) {
          data.teamSet.forEach((team) => {
            team.ownerType = 'TEAM';
          });
          this.groupedOptions = this.groupedOptions.concat(this.teamHeader, data.teamSet);
        } else {
          this.teamHeader.title = 'Нет команд';
          this.groupedOptions = this.groupedOptions.concat(this.teamHeader);
        }
        if (this.createdObjectType !== 'SUBGROUP') {
          if (data.companySet?.length > 0) {
            data.companySet.forEach((company) => {
              company.ownerType = 'COMPANY';
            });
            this.groupedOptions = this.groupedOptions.concat(this.companyHeader, data.companySet);
          } else {
            this.companyHeader.title = 'Нет компаний';
            this.groupedOptions = this.groupedOptions.concat(this.companyHeader);
          }
        }
      }

      let currentOwnerInfo = this.findInfoByType(
        data,
        this.ownerTypeFromQuery,
        this.ownerAliasFromQuery
      );

      this.selectedModel =
        this.isTransferRepository && !currentOwnerInfo ? this.ownerAlias : currentOwnerInfo;

      this.$emit('input', this.selectedModel);
    },
    onChange(e) {
      if (!e.alias && this.isTransferRepository) {
        e.alias = e.title;
      }
      this.$emit('input', e);
    },
    getParamsFromURL() {
      let queryString = window.location.search;

      if (!queryString) return;

      let urlParams = new URLSearchParams(queryString);

      if (urlParams.has('alias')) {
        this.ownerAliasFromQuery = urlParams.get('alias');
      }
      if (urlParams.has('type')) {
        this.ownerTypeFromQuery = urlParams.get('type');
      }
    },
    findInfoByType(data, ownerType, alias) {
      switch (ownerType) {
        case 'USER':
          return this.isTransferRepository
            ? data.userSet.find((user) => user.alias === this.ownerAlias)
            : data.user;
        case 'TEAM':
          return data.teamSet.find((team) => team.alias === alias);
        case 'COMPANY':
          return data.companySet.find((company) => company.alias === alias);
        default:
          return null;
      }
    }
  }
};
</script>
